import { toQuery, type HttpClient } from '../client';

/**
 * 时效（SLA）达成率统计（`/api/wl/stats/*`，后端 SlaStatsService）：
 * 数据来自业务表实时聚合，避免「只有 is_overtime 标记、没有达成率」的口径缺口。
 * 权限：`wl:analytics:view`。
 */
export interface SlaStatsQuery {
  /** yyyy-MM-dd，缺省当月 1 日。 */
  from?: string;
  /** yyyy-MM-dd，缺省今天。 */
  to?: string;
  supplierId?: string;
}

export interface ApprovalSlaNodeRow {
  nodeCode: string;
  nodeName: string | null;
  taskCount: number;
  avgHours: number;
  maxHours: number;
  overtimeCount: number;
  /** 百分比（0~100）。 */
  onTimeRate: number;
}

export interface ApprovalSlaResult {
  from: string;
  to: string;
  taskCount: number;
  avgHours: number;
  overtimeCount: number;
  onTimeRate: number;
  nodes: ApprovalSlaNodeRow[];
}

export interface DeliverySlaRow {
  supplierId: string;
  deptId: string;
  deptName: string | null;
  deliveryCount: number;
  avgHours: number;
  overtimeCount: number;
  /** 百分比（0~100）。 */
  onTimeRate: number;
}

export interface DeliverySlaResult {
  from: string;
  to: string;
  deliveryCount: number;
  overtimeCount: number;
  onTimeRate: number;
  avgHours: number;
  rows: DeliverySlaRow[];
}

export function createStatsApi(http: HttpClient) {
  return {
    approvalSla(query: SlaStatsQuery = {}): Promise<ApprovalSlaResult> {
      return http.request<ApprovalSlaResult>({ path: '/wl/stats/approval-sla', query: toQuery(query) });
    },

    deliverySla(query: SlaStatsQuery = {}): Promise<DeliverySlaResult> {
      return http.request<DeliverySlaResult>({ path: '/wl/stats/delivery-sla', query: toQuery(query) });
    }
  };
}

export type StatsApi = ReturnType<typeof createStatsApi>;
